import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSport$1 = /*@__PURE__*/ proxyCustomElement(class WppIconSport extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-sport", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM9.25 10.75V16.4572C7.99972 16.3136 6.85736 15.8152 5.92611 15.0652C6.22014 14.7178 6.59504 14.2514 6.90978 13.6691C7.31043 12.9279 7.62996 11.9892 7.72269 10.75H9.25ZM6.2177 10.75C6.13042 11.725 5.87701 12.4253 5.59022 12.9558C5.35947 13.3827 5.11406 13.6974 4.86844 13.9901C4.15546 13.0745 3.68217 11.963 3.5428 10.75H6.2177ZM7.7227 9.25H9.25V3.5428C7.99973 3.68644 6.85737 4.18484 5.92612 4.93478C6.22015 5.28219 6.59504 5.74858 6.90978 6.33085C7.31043 7.07205 7.62996 8.01074 7.7227 9.25ZM4.86845 6.00988C5.11407 6.30262 5.35948 6.61725 5.59022 7.04412C5.87702 7.57469 6.13043 8.27496 6.2177 9.25H3.5428C3.68217 8.03696 4.15547 6.92551 4.86845 6.00988ZM10.75 10.75V16.4572C12.0003 16.3136 13.1426 15.8152 14.0739 15.0652C13.7798 14.7178 13.405 14.2514 13.0902 13.6692C12.6896 12.928 12.37 11.9893 12.2773 10.75H10.75ZM16.4572 10.75C16.3178 11.963 15.8445 13.0745 15.1315 13.9901C14.8859 13.6974 14.6405 13.3828 14.4098 12.9559C14.123 12.4253 13.8696 11.725 13.7823 10.75H16.4572ZM16.4572 9.25H13.7823C13.8696 8.27498 14.123 7.57472 14.4098 7.04415C14.6405 6.61727 14.8859 6.30264 15.1316 6.00989C15.8445 6.92552 16.3178 8.03697 16.4572 9.25ZM10.75 3.5428C12.0003 3.68645 13.1426 4.18484 14.0739 4.93479C13.7799 5.28221 13.405 5.7486 13.0902 6.33088C12.6896 7.07207 12.37 8.01076 12.2773 9.25H10.75V3.5428Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-sport-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-sport", "wpp-icon-sport-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-sport-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-sport-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSport$1);
      }
      break;
  } });
}

const WppIconSport = WppIconSport$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconSport, defineCustomElement };
